import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import { useStyles } from "./styled";

import g01 from "../../../assets/image/gtns-gallery/nckh-01.jpg";
import g02 from "../../../assets/image/gtns-gallery/nckh-02.jpg";
import g03 from "../../../assets/image/gtns-gallery/nckh-03.jpg";
import g04 from "../../../assets/image/gtns-gallery/nckh-04.jpg";
import g05 from "../../../assets/image/gtns-gallery/nckh-05.jpg";
import g06 from "../../../assets/image/gtns-gallery/nckh-06.jpg";
import g07 from "../../../assets/image/gtns-gallery/nckh-07.jpg";
import g08 from "../../../assets/image/gtns-gallery/nckh-08.webp";
import g09 from "../../../assets/image/gtns-gallery/nckh-09.jpg";
import g10 from "../../../assets/image/gtns-gallery/nckh-10.jpg";
import g11 from "../../../assets/image/gtns-gallery/nckh-11.jpg";
import g12 from "../../../assets/image/gtns-gallery/nckh-12.jpg";
import g13 from "../../../assets/image/gtns-gallery/nckh-13.jpg";

// Danh sách ảnh lễ trao giải (folder NCKH_image), theo đúng thứ tự 1..13.
// large: true -> ảnh để to (chiếm trọn hàng). Theo yêu cầu: stt 2, 5, 8, 9, 12.
const GALLERY = [
  {
    src: g01,
    caption:
      "Phó Thủ tướng Chính phủ Nguyễn Thiện Nhân chụp ảnh lưu niệm cùng 20 nữ sinh xuất sắc đạt Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học kỹ thuật năm 2011",
  },
  {
    src: g02,
    large: true,
    caption:
      "Bí thư Trung ương Đoàn Nguyễn Anh Tuấn trao thưởng cho các nữ sinh xuất sắc đạt Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học kỹ thuật năm 2016",
  },
  {
    src: g03,
    caption:
      "Phó Chủ tịch thường trực Quốc hội Tòng Thị Phóng trao quà lưu niệm cho các nữ sinh xuất sắc đạt Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học kỹ thuật năm 2017",
  },
  {
    src: g04,
    caption:
      "Bí thư thường trực Trung ương Đoàn Nguyễn Anh Tuấn chụp ảnh lưu niệm cùng các nữ sinh xuất sắc đạt Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học công nghệ năm 2018",
  },
  {
    src: g05,
    large: true,
    caption:
      "Bí thư Trung ương Đoàn Bùi Quang Huy trao thưởng cho các nữ sinh xuất sắc đạt Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học công nghệ năm 2019",
  },
  {
    src: g06,
    caption:
      "Các nữ sinh xuất sắc nhận Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học công nghệ năm 2020",
  },
  {
    src: g07,
    caption:
      "Các nữ sinh xuất sắc nhận Phần thưởng Nữ sinh viên tiêu biểu trong lĩnh vực Khoa học công nghệ năm 2021",
  },
  {
    src: g08,
    large: true,
    caption:
      "Phó Chủ tịch nước Võ Thị Ánh Xuân tặng quà động viên các nữ sinh xuất sắc đạt Giải thưởng nữ sinh Khoa học công nghệ Việt Nam năm 2022",
  },
  {
    src: g09,
    large: true,
    caption:
      "Phó Chủ tịch nước Võ Thị Ánh Xuân chụp ảnh lưu niệm cùng các nữ sinh đạt Giải thưởng Nữ sinh Khoa học công nghệ Việt Nam",
  },
  {
    src: g10,
    caption:
      "Bí thư Trung ương Đoàn Nguyễn Minh Triết và Phó Chủ tịch Viện Hàn lâm Khoa học và Công nghệ Việt Nam PGS.TS. Trần Tuấn Anh chụp ảnh lưu niệm cùng các nữ sinh xuất sắc Giải thưởng nữ sinh năm 2024",
  },
  {
    src: g11,
    caption:
      "Các nữ sinh xuất sắc nhận Giải thưởng Nữ sinh khoa học công nghệ Việt Nam năm 2024 chụp ảnh lưu niệm tại Phủ Chủ tịch",
  },
  {
    src: g12,
    large: true,
    caption:
      "Bí thư Trung ương Đoàn Nguyễn Minh Triết và Thứ trưởng thường trực Bộ Y tế Vũ Mạnh Hà trao Giải thưởng nữ sinh khoa học công nghệ Việt Nam năm 2025",
  },
  {
    src: g13,
    caption:
      "Bí thư Trung ương Đoàn Nguyễn Minh Triết và Thứ trưởng thường trực Bộ Y tế Vũ Mạnh Hà chụp ảnh lưu niệm cùng các nữ sinh đạt Giải thưởng Nữ sinh khoa học công nghệ",
  },
];

// Slider đơn giản: hiển thị `perView` ảnh mỗi khung, có nút trái/phải.
function Carousel({ items, perView, classes, onOpen, large }) {
  const [start, setStart] = useState(0);
  const step = Math.max(1, perView);
  const maxStart = Math.max(0, items.length - perView);
  const clamp = (n) => Math.max(0, Math.min(n, maxStart));
  const prev = () => setStart((s) => clamp(s - step));
  const next = () => setStart((s) => clamp(s + step));

  // Tự động chạy chậm (quay vòng về đầu khi đến cuối)
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused || items.length <= perView) return undefined;
    const id = setInterval(() => {
      setStart((s) => (s >= maxStart ? 0 : Math.min(s + 1, maxStart)));
    }, 4500);
    return () => clearInterval(id);
  }, [paused, items.length, perView, maxStart]);

  if (!items || items.length === 0) return null;

  return (
    <Box
      className={classes.carousel}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <IconButton
        className={`${classes.carouselBtn} ${classes.carouselPrev}`}
        onClick={prev}
        disabled={start <= 0}
        aria-label="Ảnh trước"
      >
        <NavigateBeforeIcon />
      </IconButton>
      <Box className={classes.viewport}>
        <Box
          className={classes.track}
          style={{ transform: `translateX(-${start * (100 / perView)}%)` }}
        >
          {items.map((item, index) => (
            <Box
              key={index}
              className={classes.slide}
              style={{ flex: `0 0 ${100 / perView}%` }}
              onClick={() => onOpen(item)}
            >
              <Box className={classes.slideInner}>
                <img
                  src={item.src}
                  alt={item.caption || `Lễ trao giải Nữ sinh KHCN ${index + 1}`}
                  loading="lazy"
                  className={classes.slideImg}
                  style={{ height: large ? 460 : 220 }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <IconButton
        className={`${classes.carouselBtn} ${classes.carouselNext}`}
        onClick={next}
        disabled={start >= maxStart}
        aria-label="Ảnh sau"
      >
        <NavigateNextIcon />
      </IconButton>
    </Box>
  );
}

export default function CeremonyGallery() {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const [openIndex, setOpenIndex] = useState(-1);

  const largeItems = GALLERY.filter((e) => e.large);
  const smallItems = GALLERY.filter((e) => !e.large);
  const smallPerView = isXs ? 1 : isSm ? 2 : 3;
  const openItem = (item) => setOpenIndex(GALLERY.indexOf(item));

  const isOpen = openIndex >= 0;
  const close = useCallback(() => setOpenIndex(-1), []);
  const prev = useCallback(
    () => setOpenIndex((i) => (i <= 0 ? GALLERY.length - 1 : i - 1)),
    []
  );
  const next = useCallback(
    () => setOpenIndex((i) => (i >= GALLERY.length - 1 ? 0 : i + 1)),
    []
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, prev, next, close]);

  return (
    <>
      {/* Slider ảnh tiêu biểu (ảnh to) */}
      {largeItems.length > 0 && (
        <Carousel
          items={largeItems}
          perView={1}
          large
          classes={classes}
          onOpen={openItem}
        />
      )}

      {/* Slider ảnh nhỏ */}
      {smallItems.length > 0 && (
        <Box marginTop={3}>
          <Carousel
            items={smallItems}
            perView={smallPerView}
            classes={classes}
            onOpen={openItem}
          />
        </Box>
      )}

      <Dialog
        open={isOpen}
        onClose={close}
        maxWidth="lg"
        fullScreen={fullScreen}
        PaperProps={{ className: classes.lightboxPaper }}
      >
        <IconButton className={classes.closeBtn} onClick={close} aria-label="Đóng">
          <CloseIcon />
        </IconButton>
        <IconButton
          className={`${classes.navBtn} ${classes.navPrev}`}
          onClick={prev}
          aria-label="Ảnh trước"
        >
          <NavigateBeforeIcon fontSize="large" />
        </IconButton>
        <IconButton
          className={`${classes.navBtn} ${classes.navNext}`}
          onClick={next}
          aria-label="Ảnh sau"
        >
          <NavigateNextIcon fontSize="large" />
        </IconButton>
        {isOpen && (
          <Box className={classes.lightboxContent}>
            <img
              src={GALLERY[openIndex].src}
              alt={GALLERY[openIndex].caption || "Lễ trao giải Nữ sinh KHCN"}
              className={classes.lightboxImage}
            />
            <Box className={classes.lightboxFooter}>
              <Typography variant="body2" className={classes.counter}>
                {openIndex + 1} / {GALLERY.length}
              </Typography>
              {GALLERY[openIndex].caption ? (
                <Typography variant="body2" className={classes.caption}>
                  {GALLERY[openIndex].caption}
                </Typography>
              ) : null}
            </Box>
          </Box>
        )}
      </Dialog>
    </>
  );
}
